import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const integrationRoutes = {
    GET_BY_COMPANY_AND_TYPE: "/dashboard/report/integration/find",
    GET_WITH_PROPERTIES: "/dashboard/report/integration/get",
    SAVE_INTEGRATION: "/dashboard/report/integration/save",
}
export default {
    findByCompanyAndType(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(integrationRoutes.GET_BY_COMPANY_AND_TYPE, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code < 0) {
                        toast.error(data.message)
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        })
    },
    getWithProperties(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(integrationRoutes.GET_WITH_PROPERTIES, {params: objParams})
                .then(({data}) => {
                    const code = data.code;
                    if (code < 0) {
                        toast.error(data.message)
                        return;
                    }

                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        })
    },
    saveIntegration(integration) {
        return new Promise(resolve => {
            let code = -1;
            let newData = {};
            http.post(integrationRoutes.SAVE_INTEGRATION, integration)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se han guardado correctamente");
                        newData = data;
                        return;
                    }
                    toast.error(data.message);
                    newData = data;
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }

}
